export const appBoxDataHooks = {
    container: 'app-box-container',
};
//# sourceMappingURL=data-hooks.js.map